export const EResellerCommissionEntryStatus = {
  Accrued: 0,
  PaidOut: 1,
} as const

export type EResellerCommissionEntryStatus =
  (typeof EResellerCommissionEntryStatus)[keyof typeof EResellerCommissionEntryStatus]
